/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CouponStats
 */
export interface CouponStats {
    /**
     * 
     * @type {string}
     * @memberof CouponStats
     */
    coupon?: string;
    /**
     * 
     * @type {number}
     * @memberof CouponStats
     */
    amount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CouponStats
     */
    spends?: MoneyOutput;
}

/**
 * Check if a given object implements the CouponStats interface.
 */
export function instanceOfCouponStats(value: object): value is CouponStats {
    return true;
}

export function CouponStatsFromJSON(json: any): CouponStats {
    return CouponStatsFromJSONTyped(json, false);
}

export function CouponStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponStats {
    if (json == null) {
        return json;
    }
    return {
        
        'coupon': json['coupon'] == null ? undefined : json['coupon'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'spends': json['spends'] == null ? undefined : MoneyOutputFromJSON(json['spends']),
    };
}

export function CouponStatsToJSON(json: any): CouponStats {
    return CouponStatsToJSONTyped(json, false);
}

export function CouponStatsToJSONTyped(value?: CouponStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coupon': value['coupon'],
        'amount': value['amount'],
        'spends': MoneyOutputToJSON(value['spends']),
    };
}

